import { render, staticRenderFns } from "./AllLot.vue?vue&type=template&id=4fbfccb2"
import script from "./AllLot.vue?vue&type=script&lang=js"
export * from "./AllLot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports